import { licensePresetInitialData } from "./InitialData"

export type LicensePresetsTableType = {
  licensePresetID: number
  licenses: number
  title: string
  presetLicenses: []
}

const convertToLicensePresetReport = (data: licensePresetInitialData): LicensePresetsTableType[] => {

  const licensePresets = data?.presets ?? []

  const licensePresetData = licensePresets.map(licensePreset => ({
    licensePresetID: licensePreset.licensePresetID ?? 0,
    licenses: licensePreset.licenses ?? 0,
    title: licensePreset.title ?? '',
    presetLicenses: licensePreset.presetLicenses ?? [],
  }));

  return licensePresetData;
  
}

export const LicensePresetTableData = (data: licensePresetInitialData): LicensePresetsTableType[] => {
  return convertToLicensePresetReport(data)
}
